import supabase from '@/utils/supabase';
import { redirect } from 'react-router';
import type { MiddlewareFunction } from 'react-router';
import { profileContext } from '@/context';

export function authMiddleware(allowedRoles: string[]): MiddlewareFunction {
  return async ({ context }) => {
    const {
      data: { session },
    } = await supabase.auth.getSession();

    if (!session) {
      throw redirect('/login');
    }

    const { data: profile, error } = await supabase
      .from('profile')
      .select('role, client_id')
      .eq('id', session.user.id)
      .single();
    if (error || !profile) {
      throw redirect('/login');
    }

    if (!allowedRoles.includes(profile.role)) {
      throw redirect('/lobby');
    }

    if (profile.role === 'client' && !profile.client_id) {
      throw redirect('/lobby');
    }

    context.set(profileContext, profile);
  };
}
